import type { AvatarDesignTokens, AvatarTokenSections } from '@primeuix/themes/types/avatar';

export const root: AvatarTokenSections.Root = {
    width: '2.5rem',
    height: '2.5rem',
    fontSize: '1rem',
    background: '{content.background}',
    color: '{content.color}',
    borderRadius: '{content.borderRadius}'
};

export const icon: AvatarTokenSections.Icon = {
    size: '1.25rem'
};

export const group: AvatarTokenSections.Group = {
    borderColor: '{content.borderColor}',
    offset: '-0.75rem'
};

export const lg: AvatarTokenSections.Lg = {
    width: '3.5rem',
    height: '3.5rem',
    fontSize: '1.25rem',
    icon: {
        size: '1.75rem'
    },
    group: {
        offset: '-1rem'
    }
};

export const xl: AvatarTokenSections.Xl = {
    width: '5rem',
    height: '5rem',
    fontSize: '1.5rem',
    icon: {
        size: '2.5rem'
    },
    group: {
        offset: '-1.25rem'
    }
};

export default {
    root,
    icon,
    group,
    lg,
    xl
} satisfies AvatarDesignTokens;
